import { render, staticRenderFns } from "./CarouselArrow.vue?vue&type=template&id=4752e50c&scoped=true"
import script from "./CarouselArrow.vue?vue&type=script&lang=js"
export * from "./CarouselArrow.vue?vue&type=script&lang=js"
import style0 from "./CarouselArrow.vue?vue&type=style&index=0&id=4752e50c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4752e50c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/CarouselArrow.vue
// module id = 173
// module chunks = 0